import { Stack } from '@mui/material';
import { useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Divider } from '@work4all/components/lib/dataDisplay/divider/Divider';
import { CheckboxRadioItem } from '@work4all/components/lib/input/checkbox-radio-item';

import { ReportOptionsStruct } from '@work4all/models/lib/Classes/ReportOptionsStruct.entity';
import { ReportOptionsValue } from '@work4all/models/lib/Classes/ReportOptionsValue.entity';

export interface DevExpressReportOptionsConfProps {
  options: ReportOptionsStruct[];
  onOptionsChange: (value: ReportOptionsValue[]) => void;
}

export const DevExpressReportOptionsConf = (
  props: DevExpressReportOptionsConfProps
) => {
  const { options, onOptionsChange } = props;
  const { t } = useTranslation();

  const changedOptions = useRef<ReportOptionsValue[]>([]);

  const handleOptionChange = useCallback(
    (name: string, value: string) => {
      const opt = changedOptions.current.find((x) => x.name === name);
      if (opt) {
        opt.value = value;
      } else {
        changedOptions.current.push({
          name,
          value,
        });
      }

      onOptionsChange?.([...changedOptions.current]);
    },
    [onOptionsChange]
  );

  /**
   * Reset value when options change
   */
  useEffect(() => {
    changedOptions.current = [];
  }, [options]);

  return (
    <Stack>
      {options?.length > 0 && <Divider title={t('MASK.OPTIONS')} />}
      {options?.map((opt) => {
        return (
          <CheckboxRadioItem
            label={opt.displayName}
            onChange={(e) => {
              handleOptionChange(opt.name, String(e.target.checked));
            }}
          />
        );
      })}
    </Stack>
  );
};
